import { PublicLayout } from '../components/Layout/PublicLayout'
import { useBrandCode } from '@jotta/ui/useBrandTheme'
import { I18nProvider, isLocale, useLocale } from '@jotta/i18n'
import { useParams } from 'react-router-dom'
import { AccessibilitySwitch } from '../accessibility/AccessibilitySwitch'
import { ErrorPageNotFound } from '@jotta/ui/ErrorPageNotFound'

export function AccessibilityRoute() {
  const { fileName } = useParams()
  const brandCode = useBrandCode()
  const locale = useLocale()
  const localeParameter = fileName?.replace('.html', '')
  const overrideLocale = isLocale(localeParameter) ? localeParameter : locale
  return (
    <I18nProvider overrideLocale={overrideLocale}>
      <PublicLayout section="terms" className="prose mx-auto max-w-6xl">
        <AccessibilitySwitch
          brand={brandCode}
          locale={locale}
          Fallback={ErrorPageNotFound}
        />
      </PublicLayout>
    </I18nProvider>
  )
}
